import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "data-disabled"]

import {
		computed,
		inject
	} from "vue"

	
	const __default__ = { name: 'VLegend' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	const labelId: string = inject('labelId', null) || ''

	const fieldDisabled = inject('fieldDisabled', computed(() => false))
	const fieldsetDisabled = inject('fieldsetDisabled', computed(() => false))
	const legendDisabled = computed(() => {
		return fieldDisabled.value || fieldsetDisabled.value
	})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: _unref(labelId) ?? undefined,
    "data-disabled": legendDisabled.value ? true : null,
    "data-slot": "legend",
    class: "text-base/6 font-semibold text-zinc-950 data-[disabled]:opacity-50 sm:text-sm/6 dark:text-white"
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 8, _hoisted_1))
}
}

})